// @ts-ignore
import {createSelector} from 'reselect';
// @ts-ignore
import type {InputSelector} from 'reselect';
import type {Stageset} from '../types';
import {Collections} from '../collections';
import type {CollectionState} from '../collections';

type StagesetsModuleState = {
    stagesets: CollectionState<Stageset>;
};

/*
 * Given the entire redux state, pull out just the piece of state for the stagesets reducer.
 */
const getStagesetsState = (state: StagesetsModuleState) => state.stagesets;

/*
 * Get an array of all stagesets models, ordered with deleted or inaccessible ones at the bottom
 */
export const getAll: InputSelector<StagesetsModuleState, any, Stageset[]> = createSelector(
    [Collections.makeGetModels(getStagesetsState)],
    (stagesets) => {
        // @ts-ignore
        return orderStagesets(stagesets);
    }
);

/**
 * Get all stagesets that are active status and not archived or are draft status and can be accessed
 * Used by: Entity list pipeline filters and tasks reports filters
 * Should match the logic in application/models/Stagesets.php getFilterableStagesets method
 */
export const getFilterableStagesets: InputSelector<StagesetsModuleState, any, Stageset[]> =
    createSelector([Collections.makeGetModels(getStagesetsState)], (stagesets) => {
        // @ts-ignore
        const filterableStagesets = stagesets.filter(
            // @ts-ignore
            (stageset) =>
                stageset.status === 1 ||
                stageset.status === 3 ||
                (!stageset.canAccess && stageset.status === 3)
        );

        return orderStagesets(filterableStagesets);
    });

/**
 * Sorts stagesets by putting deleted or inaccessible ones at the end
 * @param  {Array} stagesets - Array of stageset models
 * @return {Array}           - Sorted array
 */
function orderStagesets(stagesets: Stageset[] = []): Stageset[] {
    const enabledStagesets: Stageset[] = [];
    const disabledStagesets: Stageset[] = [];

    stagesets.forEach((stageset) => {
        if (stageset.canAccess && stageset.status !== 3) {
            enabledStagesets.push(stageset);
        } else {
            disabledStagesets.push(stageset);
        }
    });

    return enabledStagesets.concat(disabledStagesets);
}

/*
 * Get the `byId` portion of the stagesets state
 */
export const getById = (state: StagesetsModuleState) => {
    const stagesetsState = getStagesetsState(state);

    return Collections.getById(stagesetsState);
};
